"use client";
import { iconsMap as i } from "./iconsMap.es.js";
import { jsx as n } from "react/jsx-runtime";
var a = ({ name: o, ...r }) => {
  const t = i[o];
  return t ? /* @__PURE__ */ n(t, {
    "data-testid": "icon-svg",
    height: "100%",
    width: "100%",
    ...r
  }) : null;
};
export {
  a as default
};
